<template>
  <section class="mt-14 md:mt-14 w-full min-h-screen bg-subtleGray">
    <div class="relative border-b border-gray-300 w-full">
      <div class="p-3 pb-0 md:p-4 2xl:px-0 w-full max-w-1xl mx-auto">
        <div class="py-6 flex items-start justify-between">
          <div class="flex flex-col items-start justify-start">
            <h1 class="font-bold text-3xl text-gray-800">
              Free Files
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div
      class="my-10 2xl:my-20 w-full p-3 pb-0 md:p-6 2xl:p-0 max-w-1xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-10"
    >
      <div v-for="product in getFreeProducts" :key="product.id" class="">
        <ProductVideoCard
          v-if="!product.peaks"
          :id="product.id"
          :thumbnail="product.thumbnailUrl"
          :category="product.category"
          :video="product.previewUrl"
          :author="product.user.userName"
          :authorId="product.user.id"
          :title="product.productName"
          :date="product.updatedAt.split('T')[0]"
          :free="true"
        />

        <NewMiniAudio
          v-else
          :currentCategory="product.category"
          :id="product.id"
          :audioUrl="product.previewUrl"
          :category="product.category"
          :author="product.user.userName"
          :authorId="product.user.id"
          :title="product.productName"
          :peaks="product.peaks"
          :trackLength="product.trackLength"
          :bpm="product.tempo"
          :length="product.length"
          :date="product.updatedAt.split('T')[0]"
          :free="true"
        />
      </div>
    </div>

    <!-- pagination -->

    <Pagination
      v-if="getFreeProducts && getFreeProducts.length > 0"
      class=""
      type="half"
      :pages="getCurrentPage"
      :selected="selectedPage"
      v-on:currentPage="handleCurrentPageChange($event)"
    />
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CollectionCard from "../components/utils/CollectionCard.vue";
import MiniProductAudioCard from "../components/utils/MiniProductAudioCard.vue";
import NewMiniAudio from "../components/utils/NewMiniAudio.vue";
import Pagination from "../components/utils/Pagination.vue";
import ProductVideoCard from "../components/utils/ProductVideoCard.vue";
export default {
  name: "free files",
  components: {
    CollectionCard,
    ProductVideoCard,
    MiniProductAudioCard,
    Pagination,
    NewMiniAudio,
  },
  computed: {
    ...mapGetters(["getCurrentPage"]),
    ...mapGetters(["getFreeProducts"]),
  },
  mounted() {
    this.fetchFreeProduct(1);
  },
  methods: {
    ...mapActions(["fetchFreeProduct"]),
    handleCurrentPageChange(e) {
      this.selectedPage = e;
    },
  },

  data() {
    return { selectedPage: 1 };
  },

  watch: {
    selectedPage: function(nv, ov) {
      this.fetchFreeProduct(nv);
    },
  },
};
</script>
<style scoped>
.pattern {
  background-color: #181818;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(0,842,429)'%3E%3Cstop offset='0' stop-color='%23181818'/%3E%3Cstop offset='1' stop-color='%23404040'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='436' height='363.3' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.1'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
</style>
